import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./permission";
import "animate.css";
import wow from "wowjs";
import "@/utils/eventList.js";

Vue.prototype.$wow = wow;
import "@/assets/style/common.less";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./icons"; // icon

import { initMessage } from "./utils/element-ui";
// import { USE_MOCK } from "./config";

Vue.use(ElementUI);
initMessage(ElementUI.Message);
Vue.config.productionTip = false;
// import "@/utils/wx.js";

window.vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");

window.appBuildTime = process.env.VUE_APP_BUILD_TIME;
window.appVersion = process.env.VUE_APP_VERSION;
window.appBranch = process.env.VUE_APP_BRANCH;
window.appAuthor = () => process.env.VUE_APP_AUTHOR;
console.log("app Version: " + window.appVersion);
console.log("app BuildTime: " + window.appBuildTime);
console.log("app Branch: " + window.appBranch);
